import React from 'react'
import { LogoImg } from './styled'

const NavbarLogo: React.FC = () => {
    return <LogoImg src="/assets/img/login-bg/triko-logo.png" />
}

export default NavbarLogo
